import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "24e9aada-1777-4c2a-9cf3-2cd4f9b42d51",
    content: "... are inserted between the amplifier and the speaker.",
    options: {},
  },
  {
    id: "3e29d993-1f54-4ba4-91a2-00e0e5468c3e",
    content: "... provide a better isolation of each driver.",
    options: {},
  },
  { id: "0962efb1-ce85-4d46-9241-bb1533f4ccc1", content: "... cannot provide gain.", options: {} },
  { id: "b4ec40ed-5c1a-4bdb-8137-0cb5ce692568", content: "... do not need to be powered.", options: {} },
  {
    id: "32d64943-1a69-445c-bab4-b7fa84c51d6e",
    content: "... require one amplifier for each output band.",
    options: {},
  },
  {
    id: "88c6b41e-f3a3-482d-bb8c-d1075c297858",
    content: "... offers more flexibility than passive filters.",
    options: {},
  },
];

export const task: Task = {
  id: "2f9cb076-2cfd-4ae1-b318-84c1bb55fc3d",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "3e29d993-1f54-4ba4-91a2-00e0e5468c3e",
    "32d64943-1a69-445c-bab4-b7fa84c51d6e",
    "88c6b41e-f3a3-482d-bb8c-d1075c297858",
  ],
};
